/* NOVATEA v6 — JS principal */
document.addEventListener('DOMContentLoaded', function() {

  // Header scroll
  var header = document.getElementById('nt-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, {passive: true});
  }

  // Burger menu mobile
  var burger = document.getElementById('nt-burger');
  var mobileNav = document.getElementById('nt-mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function() {
      var open = burger.classList.toggle('open');
      mobileNav.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    // Fermer sur clic lien
    mobileNav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        burger.classList.remove('open');
        mobileNav.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  // Fade-up animations
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); }
      });
    }, {threshold: 0.1, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.fade-up').forEach(function(el) { observer.observe(el); });
  } else {
    document.querySelectorAll('.fade-up').forEach(function(el) { el.classList.add('visible'); });
  }

  // Qty buttons
  document.querySelectorAll('.qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.closest('.product-qty').querySelector('.qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      else val = val + 1;
      input.value = val;
    });
  });

  // Gallery thumbs
  document.querySelectorAll('.product-gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var main = document.querySelector('.product-gallery-main img');
      if (main && thumb.dataset.src) {
        main.src = thumb.dataset.src;
        document.querySelectorAll('.product-gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });

});
